($ => {
  "use strict";
  class RadioDropdown {
    constructor({ wrapper }) {
      this.elements = {
        wrapper,
        toggle: wrapper.querySelector('.js-dropdown-toggle'),
        label: wrapper.querySelector('.js-dropdown-label'),
        options_container: wrapper.querySelector('.js-dropdown-options-container'),
        options_radios: [...wrapper.querySelectorAll('.js-dropdown-option-radio')],
        options_labels: [...wrapper.querySelectorAll('.js-dropdown-option-label')]
      };

      this.init();
      
    }

    uniqueNumber(length) {
      this._rendered_numbers = [];

      var length = length || 6;
      var id = Math.floor(Math.random() * Math.pow(10, length));

      while (this._rendered_numbers.indexOf(id) !== -1) {
        id = Math.floor(Math.random() * Math.pow(10, length));
      }

      // Keep track of the generated number so that it is never generated again.
      this._rendered_numbers.push(id);

      return id;
    }
    init() {

      // init toggle event
      this.elements.toggle.addEventListener('click', (e) => {
        e.preventDefault();
        this._toggleDropdown();

        // to close the select by clicking outside of it
        let event_name = `click.closeSelect--${this.uniqueNumber()}`;
        if (this.elements.toggle.classList.contains('is-open')) {
          $(document).on(event_name, e => {
            if ($(this.elements.wrapper).has(e.target).length === 0) {
              this._closeDropdown();
              $(document).off(event_name);
            }
          })

          let material_tooltip = document.querySelector('.product-tooltip--material');
          material_tooltip.addEventListener('mouseover', () => {
            this._closeDropdown();
          })
        } else {
          $(document).off(event_name);
        }
      });

      // init options event
      this.elements.options_radios.forEach((option, index) => option.addEventListener('click', () => {
        option.classList.add('is-checked');
        option.checked = true;
        this.elements.options_container.classList.contains('js-dropdown-options-container--qty') || this.elements.options_container.classList.contains('js-dropdown-options-container--material') ? this.elements.label.innerText = this.elements.options_labels[index].childNodes[0].innerText : this.elements.label.innerText = this.elements.options_labels[index].innerText;
        let custom_parent = option.closest('.box-option');
        let custom_container = custom_parent ? custom_parent.getElementsByClassName('js-custom-input-container')[0] : null;

        if(custom_container && !custom_container.classList.contains('is-hidden')) {
          custom_container.classList.add('is-hidden');
          custom_container.closest('.box-option').getElementsByClassName('js-custom-input-msg')[0].classList.remove('is-hidden');
          custom_container.closest('.box-option').getElementsByClassName('js-custom-input-label')[0].classList.add('is-hidden');
        }

        this._closeDropdown();
      }));

      // init keyboard key events
      [this.elements.toggle, ...this.elements.options_labels].forEach((btn, index, array) => btn.addEventListener('keydown', (e) => {
        if (!this.elements.toggle.classList.contains('is-open')) {
          return;
        }
        let i = index;
        switch(e.key) {
          case 'ArrowUp':
            // Focus to previous available element
            i--;
            while(i >= 0) {
              if (array[i].getAttribute('tabindex') === '-1') {
                i--;
                continue;
              }
              e.preventDefault();
              array[i].focus();
              break;
            }
            break;

          case 'ArrowDown':
            // Focus to next available element
            i++;
            while(i < array.length) {
              if (array[i].getAttribute('tabindex') === '-1') {
                i++;
                continue;
              }
              e.preventDefault();
              array[i].focus();
              break;
            }
            break;

          case 'Escape':
            // Close the select if you press the escape key
            e.preventDefault();
            this._closeDropdown();
            break;
          default:
            break;
        }
      }));
    }

    _openDropdown() {
      this.elements.toggle.classList.add('is-open');
      this.elements.toggle.setAttribute('aria-expanded', 'true');
      $(this.elements.options_container).removeClass('is-hidden');
    }

    _closeDropdown() {
      this.elements.toggle.classList.remove('is-open');
      this.elements.toggle.setAttribute('aria-expanded', 'false');
      $(this.elements.options_container).addClass('is-hidden');
    }

    _toggleDropdown() {
      this.elements.toggle.classList.contains('is-open') ? this._closeDropdown() : this._openDropdown();
    }
  }

  window.RadioDropdown = RadioDropdown;

  function initialize () {
    document.querySelectorAll('.js-dropdown-wrapper').forEach((wrapper) => {
      new RadioDropdown({ wrapper });
    });
  }


  // Document ready
  $(() => {
    initialize();
  });

  $(document).on('shopify:section:load', () => {
    initialize();
  });

})(jQuery);
